import React from 'react';
import { Card, Tabs, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import AccountInfoForm from '../../components/Profile/AccountInfoForm';
import ChangePasswordForm from '../../components/Profile/ChangePasswordForm';

const { Title, Paragraph } = Typography;

const ProfileSettingsPage: React.FC = () => {
  const items = [
    {
      label: (
        <span>
          <UserOutlined />
          Informasi Akun
        </span>
      ),
      key: '1',
      children: <AccountInfoForm />,
    },
    {
      label: (
        <span>
          <LockOutlined />
          Ubah Password
        </span>
      ),
      key: '2',
      children: <ChangePasswordForm />,
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={3} style={{ marginBottom: 4 }}>
        Pengaturan Profil
      </Title>
      <Paragraph type="secondary" style={{ marginBottom: 24 }}>
        Kelola informasi akun dan ubah password Anda di sini.
      </Paragraph>
      <Card bordered={false}>
        <Tabs defaultActiveKey="1" items={items} />
      </Card>
    </div>
  );
};

export default ProfileSettingsPage;
